import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

export const LANGUAGE_STORAGE_KEY = "leMemePrix_preferredLang";

const persistedLang = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: persistedLang() || "fr",
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

// Sync document lang + discourage browser translation when user has chosen a language
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
    document.documentElement.setAttribute("translate", "no");
    document.documentElement.setAttribute("class", `lang-${lng}`);
  }
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {}
});

// Set initial lang on load
if (typeof document !== "undefined") {
  const lng = i18n.language || "fr";
  document.documentElement.lang = lng;
  document.documentElement.setAttribute("translate", "no");
}

export default i18n;
